import request from './request'

export function getWealthCustomerPage(data) {
  return request.post('/wealth/customers/page', data)
}

export function getWealthCustomer(id) {
  return request.get(`/wealth/customers/${id}`)
}

export function createWealthCustomer(data) {
  return request.post('/wealth/customers', data)
}

export function updateWealthCustomer(id, data) {
  return request.put(`/wealth/customers/${id}`, data)
}

export function disableWealthCustomer(id, data = {}) {
  return request.post(`/wealth/customers/${id}/disable`, data)
}

export function enableWealthCustomer(id, data = {}) {
  return request.post(`/wealth/customers/${id}/enable`, data)
}

export function getWealthCustomerAccount(id) {
  return request.get(`/wealth/customers/${id}/account`)
}

export function getWealthCustomerContractPage(id, data) {
  return request.post(`/wealth/customers/${id}/contracts/page`, data)
}

export function getWealthContractPage(data) {
  return request.post('/wealth/contracts/page', data)
}

export function getWealthContract(id) {
  return request.get(`/wealth/contracts/${id}`)
}

export function submitWealthInvestApply(data) {
  return request.post('/wealth/operation-applies/invest', data)
}

export function submitWealthIncreaseApply(contractId, data) {
  return request.post(`/wealth/operation-applies/contracts/${contractId}/increase`, data)
}

export function submitWealthDecreaseApply(contractId, data) {
  return request.post(`/wealth/operation-applies/contracts/${contractId}/decrease`, data)
}

export function submitWealthWithdrawApply(contractId, data) {
  return request.post(`/wealth/operation-applies/contracts/${contractId}/withdraw`, data)
}

export function submitWealthRolloverApply(batchId, data) {
  return request.post(`/wealth/operation-applies/batches/${batchId}/rollover`, data)
}

export function cancelWealthOperationApply(id, data = {}) {
  return request.post(`/wealth/operation-applies/${id}/cancel`, data)
}

export function getWealthOperationApply(id) {
  return request.get(`/wealth/operation-applies/${id}`)
}

export function getWealthOperationApplyByApprovalInstanceId(approvalInstanceId) {
  return request.get(`/wealth/operation-applies/by-approval-instance/${approvalInstanceId}`)
}

export function getWealthOperationApplyPage(data) {
  return request.post('/wealth/operation-applies/page', data)
}

export function getWealthOperationApplyBatchDetails(id) {
  return request.get(`/wealth/operation-applies/${id}/batch-details`)
}

export function getWealthOperationApplyBatchDetailsByApprovalInstanceId(approvalInstanceId) {
  return request.get(`/wealth/operation-applies/by-approval-instance/${approvalInstanceId}/batch-details`)
}

export function getWealthFundBatchPage(data = {}) {
  return request.post('/wealth/batches/page', data)
}

export function getWealthFundBatch(id) {
  return request.get(`/wealth/batches/${id}`)
}

export function getWealthContractBatchPage(contractId, data = {}) {
  return request.post(`/wealth/contracts/${contractId}/batches`, data)
}

export function getWealthUpcomingMaturityBatchPage(data = {}) {
  return request.post('/wealth/batches/upcoming-maturity', data)
}

export function getWealthMaturedUnhandledBatchPage(data = {}) {
  return request.post('/wealth/batches/matured-unhandled', data)
}

export function getWealthFundLedgerPage(data) {
  return request.post('/wealth/ledgers/page', data)
}

export function getWealthFundLedger(id) {
  return request.get(`/wealth/ledgers/${id}`)
}

export function getWealthFundLedgerBatchDetails(id) {
  return request.get(`/wealth/ledgers/${id}/batch-details`)
}

export function getWealthContractLedgerPage(contractId, data = {}) {
  return request.post(`/wealth/contracts/${contractId}/ledgers`, data)
}

export function getWealthBatchLedgerPage(batchId, data = {}) {
  return request.post(`/wealth/batches/${batchId}/ledgers`, data)
}

export function bindWealthContractAttachments(id, data) {
  return request.post(`/wealth/contracts/${id}/attachments`, data)
}

export function voidWealthContractAttachment(id, attachmentId, data) {
  return request.post(`/wealth/contracts/${id}/attachments/${attachmentId}/void`, data)
}

export function bindWealthOperationApplyAttachments(id, data) {
  return request.post(`/wealth/operation-applies/${id}/attachments`, data)
}

export function voidWealthOperationApplyAttachment(id, attachmentId, data) {
  return request.post(`/wealth/operation-applies/${id}/attachments/${attachmentId}/void`, data)
}

export function getWealthAttachments(params) {
  return request.get('/wealth/attachments', { params })
}

export function getWealthDataPermissionPage(data) {
  return request.post('/wealth/data-permissions/page', data)
}

export function saveWealthDataPermission(data) {
  return request.post('/wealth/data-permissions', data)
}

export function disableWealthDataPermission(id, data = {}) {
  return request.post(`/wealth/data-permissions/${id}/disable`, data)
}

export function enableWealthDataPermission(id, data = {}) {
  return request.post(`/wealth/data-permissions/${id}/enable`, data)
}

export function getWealthStatisticsOverview() {
  return request.get('/wealth/statistics/overview')
}

export function getWealthStatisticsByOwner() {
  return request.get('/wealth/statistics/by-owner')
}

export function getWealthStatisticsByRiskLevel() {
  return request.get('/wealth/statistics/by-risk-level')
}

export function getWealthStatisticsBySource() {
  return request.get('/wealth/statistics/by-source')
}
